import how_to_compress_images from 'assets/img/how-to-section/how-to-new-design-compress-images.svg';
import how_to_compress_pdf from 'assets/img/how-to-section/how-to-new-design-compress-pdf.svg';
import {
  default as how_to_delete_pages_pdf,
  default as how_to_edit_pdf
} from 'assets/img/how-to-section/how-to-new-design-edit-pdf.svg';
import { default as how_to_new_design } from 'assets/img/how-to-section/how-to-new-design-main.svg';
import how_to_sign_pdf from 'assets/img/how-to-section/how-to-new-design-sign-pdf.svg';
import icon_1 from 'assets/img/how-to-section/icon_1.svg';
import icon_2 from 'assets/img/how-to-section/icon_2.svg';
import icon_3 from 'assets/img/how-to-section/icon_3.svg';
import type { TFunction } from 'i18next';

import { EFunnels } from 'ts/enums/funnel';
import type { IService } from 'ts/interfaces/services/service';
import { EServiceType } from 'ts/interfaces/services/service';
import { InternalFileType } from 'ts/types/file';

import compress_pdf from './assets/compress_pdf.svg';
import delete_pages from './assets/delete_pages.svg';
import edit_pdf from './assets/edit_pdf_fill.svg';
import pdf_ocr from './assets/pdf_ocr.svg';
import sing_pdf from './assets/sign_pdf.svg';
import split_pdf from './assets/split_pdf.svg';

export enum EEditorServices {
  EDIT_PDF = 'edit-pdf',
  FILL_PDF = 'fill-pdf',
  DELETE_PAGES_FROM_PDF = 'delete-pages-from-pdf',
  COMPRESS_PDF = 'compress-pdf',
  SIGN_PDF = 'sign-pdf',
  SPLIT_PDF = 'split-pdf',
  CREATE_PDF = 'create-pdf',
  ROTATE_PDF = 'rotate-pdf',
  PDF_CONVERTOR = 'pdf-converter',
  IMAGE_TO_TEXT = 'image-to-text',
  PDF_OCR = 'pdf-ocr',
  TRANSLATE_PDF = 'translate-pdf',
  COMPRESS_IMAGES = 'compress-image'
}

export const signPdfService = (t: TFunction): IService => ({
  serviceType: EServiceType.EDITOR,
  path: '/sign-pdf',
  key: 'sign-pdf',
  funnel: EFunnels.SIGN_PDF,
  uploadSectionImage: sing_pdf,
  mainColor: 'ocean-blue',
  uploadSection: {
    from: InternalFileType.PDF,
    to: InternalFileType.PDF,
    headline: t('landing.signature_pdf.h1.title'),
    subtitle_1: t('landing.signature_pdf.h1.subtitle')
  },
  banner: {
    headline: t('landing.signature_pdf.h1.title'),
    subtitle: t('landing.signature_pdf.h1.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('main_page.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.signature_pdf.how_to.h2'),
    subtitle_1: t('landing.signature_pdf.h1.subtitle'),
    img: how_to_sign_pdf,
    description: [
      {
        icon: icon_1,
        text: t('landing.signature_pdf.how_to.first')
      },
      {
        icon: icon_2,
        text: t('landing.signature_pdf.how_to.second')
      },
      {
        icon: icon_3,
        text: t('landing.signature_pdf.how_to.third')
      }
    ]
  },
  title: t('meta.signature_pdf.title'),
  description: t('meta.signature_pdf.description'),
  fag: {
    question: 'Convert a PDF file to Word online in a few steps!',
    answer:
      '1. To convert a PDF file, upload it using the button "Upload" above or Drag&Drop. 2. Edit your PDF document using our tools and convert it to Word with one click. 3. Download or share the Word file.'
  },
  name: t('meta.signature_pdf.title'),
  nameKey: 'landing.signature_pdf.name',
  from: InternalFileType.PDF,
  to: InternalFileType.PDF,
  availableFormats: '.pdf'
});

export const editPdfService = (t: TFunction): IService => ({
  key: EEditorServices.EDIT_PDF,
  serviceType: EServiceType.EDITOR,
  path: 'edit-pdf',
  uploadSectionImage: edit_pdf,
  mainColor: 'berry',
  funnel: EFunnels.EDIT_PDF,
  uploadSection: {
    from: InternalFileType.PDF,
    to: InternalFileType.PDF,
    headline: t('landing.edit_pdf.h1.title'),
    subtitle_1: t('landing.edit_pdf.h1.subtitle')
  },
  banner: {
    headline: t('landing.edit_pdf.CTA.title'),
    subtitle: t('landing.edit_pdf.CTA.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('main_page.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.edit_pdf.how_to.h2'),
    img: how_to_edit_pdf,
    description: [
      {
        icon: icon_1,
        text: t('landing.edit_pdf.how_to.first')
      },
      {
        icon: icon_2,
        text: t('landing.edit_pdf.how_to.second')
      },
      {
        icon: icon_3,
        text: t('landing.edit_pdf.how_to.third')
      }
    ]
  },
  title: t('meta.edit_pdf.title'),
  description: t('meta.edit_pdf.description'),
  fag: {
    question: 'Convert a PDF file to Word online in a few steps!',
    answer:
      '1. To convert a PDF file, upload it using the button "Upload" above or Drag&Drop. 2. Edit your PDF document using our tools and convert it to Word with one click. 3. Download or share the Word file.'
  },
  name: t('meta.edit_pdf.title'),
  nameKey: 'landing.edit_pdf.name',
  from: InternalFileType.PDF,
  to: InternalFileType.PDF,
  availableFormats: '.pdf'
});

export const fillPdfService = (t: TFunction): IService => ({
  serviceType: EServiceType.EDITOR,
  key: EEditorServices.FILL_PDF,
  path: 'fill-pdf',
  uploadSectionImage: edit_pdf,
  mainColor: 'berry',
  funnel: EFunnels.FILL_PDF,
  uploadSection: {
    from: InternalFileType.PDF,
    to: InternalFileType.PDF,
    headline: t('landing.fill_pdf.h1.title'),
    subtitle_1: t('landing.fill_pdf.h1.subtitle')
  },
  banner: {
    headline: t('landing.fill_pdf.CTA.title'),
    subtitle: t('landing.fill_pdf.CTA.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('main_page.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.fill_pdf.how_to.h2'),
    img: how_to_edit_pdf,
    description: [
      {
        icon: icon_1,
        text: t('landing.fill_pdf.how_to.first')
      },
      {
        icon: icon_2,
        text: t('landing.fill_pdf.how_to.second')
      },
      {
        icon: icon_3,
        text: t('landing.fill_pdf.how_to.third')
      }
    ]
  },
  title: t('meta.fill_pdf.title'),
  description: t('meta.fill_pdf.description'),
  fag: {
    question: 'Convert a PDF file to Word online in a few steps!',
    answer:
      '1. To convert a PDF file, upload it using the button "Upload" above or Drag&Drop. 2. Edit your PDF document using our tools and convert it to Word with one click. 3. Download or share the Word file.'
  },
  name: t('meta.fill_pdf.title'),
  nameKey: 'landing.fill_pdf.name',
  from: InternalFileType.PDF,
  to: InternalFileType.PDF,
  availableFormats: '.pdf'
});

export const compressPdfService = (t: TFunction): IService => ({
  serviceType: EServiceType.COMPRESSOR,
  path: '/compress-pdf',
  key: EEditorServices.COMPRESS_PDF,
  uploadSectionImage: compress_pdf,
  funnel: EFunnels.COMPRESS_PDF,
  mainColor: 'berry',
  uploadSection: {
    from: InternalFileType.PDF,
    to: InternalFileType.PDF,
    headline: t('landing.compress_pdf.h1.title'),
    subtitle_1: t('landing.compress_pdf.h1.subtitle')
  },
  banner: {
    headline: t('landing.compress_pdf.h1.title'),
    subtitle_1: t('landing.compress_pdf.h1.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('main_page.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.compress_pdf.how_to.h2'),
    img: how_to_compress_pdf,
    description: [
      {
        icon: icon_1,
        text: t('landing.compress_pdf.how_to.first')
      },
      {
        icon: icon_2,
        text: t('landing.compress_pdf.how_to.second')
      },
      {
        icon: icon_3,
        text: t('landing.compress_pdf.how_to.third')
      }
    ]
  },
  title: t('meta.compress_pdf.title'),
  description: t('meta.compress_pdf.description'),
  fag: {
    question: 'Convert a PDF file to Word online in a few steps!',
    answer:
      '1. To convert a PDF file, upload it using the button "Upload" above or Drag&Drop. 2. Edit your PDF document using our tools and convert it to Word with one click. 3. Download or share the Word file.'
  },
  name: t('meta.compress_pdf.title'),
  nameKey: 'landing.compress_pdf.name',
  from: InternalFileType.PDF,
  to: InternalFileType.PDF,
  availableFormats: '.pdf'
});

export const pdfOcrService = (t: TFunction): IService => ({
  serviceType: EServiceType.OCR,
  path: '/pdf-ocr',
  key: EEditorServices.PDF_OCR,
  uploadSectionImage: pdf_ocr,
  funnel: EFunnels.PDF_OCR,
  mainColor: 'berry',
  name: t('meta.pdf_ocr.title'),
  nameKey: 'landing.pdf_ocr.name',
  title: t('meta.pdf_ocr.title'),
  description: t('meta.pdf_ocr.description'),
  uploadSection: {
    from: InternalFileType.PDF,
    to: InternalFileType.PDF,
    headline: t('landing.pdf_ocr.h1.title'),
    subtitle_1: t('landing.pdf_ocr.h1.subtitle')
  },
  banner: {
    headline: t('landing.pdf_ocr.CTA.title'),
    subtitle: t('landing.pdf_ocr.CTA.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('main_page.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.pdf_ocr.how_to.h2'),
    img: how_to_new_design,
    description: [
      {
        icon: icon_1,
        text: t('landing.pdf_ocr.how_to.first')
      },
      {
        icon: icon_2,
        text: t('landing.pdf_ocr.how_to.second')
      },
      {
        icon: icon_3,
        text: t('landing.pdf_ocr.how_to.third')
      }
    ]
  },
  fag: {
    question: 'Convert a PDF file to Word online in a few steps!',
    answer:
      '1. To convert a PDF file, upload it using the button "Upload" above or Drag&Drop. 2. Edit your PDF document using our tools and convert it to Word with one click. 3. Download or share the Word file.'
  },
  from: InternalFileType.PDF,
  to: InternalFileType.PDF,
  availableFormats: '.pdf, .png, .jpg, .bmp, .jpeg, .tiff, .gif, .djvu'
});

export const translatePdfService = (t: TFunction): IService => ({
  key: EEditorServices.TRANSLATE_PDF,
  serviceType: EServiceType.TRANSLATE,
  funnel: EFunnels.TRANSLATE_PDF,
  path: 'translate-pdf',
  mainColor: 'berry',
  uploadSection: {
    from: InternalFileType.PDF,
    to: InternalFileType.PDF,
    headline: t('landing.translate_pdf.h1.title'),
    subtitle_1: t('landing.translate_pdf.h1.subtitle')
  },
  banner: {
    headline: t('landing.translate_pdf.CTA.title'),
    subtitle: t('landing.translate_pdf.CTA.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('main_page.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.translate_pdf.how_to.h2'),
    subtitle_1: t('landing.translate_pdf.h1.subtitle'),
    img: how_to_edit_pdf,
    description: [
      {
        icon: icon_1,
        text: t('landing.translate_pdf.how_to.first')
      },
      {
        icon: icon_2,
        text: t('landing.translate_pdf.how_to.second')
      },
      {
        icon: icon_3,
        text: t('landing.translate_pdf.how_to.third')
      }
    ]
  },
  title: t('landing.translate_pdf.h1.title'),
  description: t('landing.translate_pdf.h1.subtitle'),
  fag: {
    question: 'Convert a PDF file to Word online in a few steps!',
    answer:
      '1. To convert a PDF file, upload it using the button "Upload" above or Drag&Drop. 2. Edit your PDF document using our tools and convert it to Word with one click. 3. Download or share the Word file.'
  },
  name: t('landing.translate_pdf.h1.title'),
  nameKey: 'landing.translate_pdf.name',
  from: InternalFileType.PDF,
  to: InternalFileType.PDF,
  availableFormats: '.pdf'
});

export const imageToTextService = (t: TFunction): IService => ({
  serviceType: EServiceType.OCR,
  mainColor: 'berry',
  path: '/image-to-text',
  funnel: EFunnels.IMAGE_TO_TEXT,
  key: EEditorServices.IMAGE_TO_TEXT,
  uploadSectionImage: pdf_ocr,
  name: t('meta.image_to_text.title'),
  nameKey: 'landing.image_to_text.name',
  title: t('meta.image_to_text.title'),
  description: t('meta.image_to_text.description'),
  uploadSection: {
    from: [
      InternalFileType.HEIC,
      InternalFileType.SVG,
      InternalFileType.PNG,
      InternalFileType.BMP,
      InternalFileType.EPS,
      InternalFileType.GIF,
      InternalFileType.TIFF,
      InternalFileType.WEBP,
      InternalFileType.JPG,
      InternalFileType.JPEG
    ],
    to: InternalFileType.PDF,
    headline: t('landing.image_to_text.h1.title'),
    subtitle_1: t('landing.image_to_text.h1.subtitle')
  },
  banner: {
    headline: t('landing.image_to_text.CTA.title'),
    subtitle: t('landing.image_to_text.CTA.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('main_page.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.image_to_text.how_to.h2'),
    img: how_to_new_design,
    subtitle_1: t('landing.image_to_text.h1.subtitle'),
    description: [
      {
        icon: icon_1,
        text: t('landing.image_to_text.how_to.first')
      },
      {
        icon: icon_2,
        text: t('landing.image_to_text.how_to.second')
      },
      {
        icon: icon_3,
        text: t('landing.image_to_text.how_to.third')
      }
    ]
  },
  fag: {
    question: 'Convert a PDF file to Word online in a few steps!',
    answer:
      '1. To convert a PDF file, upload it using the button "Upload" above or Drag&Drop. 2. Edit your PDF document using our tools and convert it to Word with one click. 3. Download or share the Word file.'
  },
  from: [
    InternalFileType.HEIC,
    InternalFileType.SVG,
    InternalFileType.PNG,
    InternalFileType.BMP,
    InternalFileType.EPS,
    InternalFileType.GIF,
    InternalFileType.TIFF,
    InternalFileType.WEBP,
    InternalFileType.JPG,
    InternalFileType.JPEG,
    InternalFileType.PDF
  ],
  to: InternalFileType.PDF,
  availableFormats: '.pdf, .png, .jpg, .bmp, .jpeg, .tiff, .gif, .djvu'
});

export const compressImagesService = (t: TFunction): IService => ({
  serviceType: EServiceType.COMPRESSOR,
  path: '/compress-images',
  key: EEditorServices.COMPRESS_IMAGES,
  funnel: EFunnels.COMPRESS_IMAGES,
  uploadSectionImage: compress_pdf,
  mainColor: 'berry',
  uploadSection: {
    from: [InternalFileType.HEIC, InternalFileType.PNG, InternalFileType.JPG, InternalFileType.JPEG],
    to: [InternalFileType.HEIC, InternalFileType.PNG, InternalFileType.JPG, InternalFileType.JPEG],
    headline: t('landing.compress_images.h1.title'),
    subtitle_1: t('landing.compress_images.h1.subtitle')
  },
  banner: {
    headline: t('landing.compress_images.h1.title'),
    subtitle: t('landing.compress_images.h1.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('landing.image_to_pdf.CTA.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.compress_images.how_to.h2'),
    subtitle_1: t('landing.compress_images.h1.subtitle'),
    img: how_to_compress_images,
    description: [
      {
        icon: icon_1,
        text: t('landing.compress_images.how_to.first')
      },
      {
        icon: icon_2,
        text: t('landing.compress_images.how_to.second')
      },
      {
        icon: icon_3,
        text: t('landing.compress_images.how_to.third')
      }
    ]
  },
  title: t('meta.compress_images.title'),
  description: t('meta.compress_images.description'),
  fag: {
    question: 'Convert a PDF file to Word online in a few steps!',
    answer:
      '1. To convert a PDF file, upload it using the button "Upload" above or Drag&Drop. 2. Edit your PDF document using our tools and convert it to Word with one click. 3. Download or share the Word file.'
  },
  name: t('meta.compress_images.title'),
  nameKey: 'landing.compress_pdf.name',
  from: [InternalFileType.HEIC, InternalFileType.PNG, InternalFileType.JPG, InternalFileType.JPEG],
  to: [InternalFileType.HEIC, InternalFileType.PNG, InternalFileType.JPG, InternalFileType.JPEG],
  availableFormats: '.png, .jpeg, .jpg, .heic'
});

export const splitPdfService = (t: TFunction): IService => ({
  serviceType: EServiceType.SPLITTER,
  path: '/split-pdf',
  key: EEditorServices.SPLIT_PDF,
  funnel: EFunnels.SPLIT_PDF,
  uploadSectionImage: split_pdf,
  name: t('meta.split_pdf.title'),
  nameKey: 'landing.split_pdf.name',
  title: t('meta.split_pdf.title'),
  from: InternalFileType.PDF,
  to: InternalFileType.PDF,
  availableFormats: '.pdf',
  mainColor: 'berry',
  uploadSection: {
    headline: t('landing.split_pdf.h1.title'),
    subtitle_1: t('landing.split_pdf.h1.subtitle'),
    to: InternalFileType.PDF,
    from: InternalFileType.PDF
  },
  howTo: {
    headline_1: t('landing.split_pdf.how_to.h2'),
    subtitle_1: t('landing.split_pdf.h1.subtitle'),
    img: how_to_edit_pdf,
    description: [
      {
        icon: icon_1,
        text: t('landing.split_pdf.how_to.first')
      },
      {
        icon: icon_2,
        text: t('landing.split_pdf.how_to.second')
      },
      {
        icon: icon_3,
        text: t('landing.split_pdf.how_to.third')
      }
    ]
  },
  banner: {
    headline: t('landing.split_pdf.CTA.title'),
    subtitle: t('landing.split_pdf.CTA.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('main_page.buttonLabel')
  },
  fag: {
    question: 'How to organize multiple PDFs documents?',
    answer:
      '1. Upload PDF files you would like to be combined. 2. Arrange files in the desired order, delete unnecessary. 3. Download or share your merged PDF file.'
  }
});

export const deletePagesFromPdfService = (t: TFunction): IService => ({
  serviceType: EServiceType.EDITOR,
  funnel: EFunnels.DELETE_PDF_PAGES,
  key: EEditorServices.DELETE_PAGES_FROM_PDF,
  path: '/delete-pages-from-pdf',
  uploadSectionImage: delete_pages,
  mainColor: 'berry',
  uploadSection: {
    from: InternalFileType.PDF,
    to: InternalFileType.PDF,
    headline: t('landing.delete_pages_from_pdf.h1.title'),
    subtitle_1: t('landing.delete_pages_from_pdf.h1.subtitle')
  },
  banner: {
    headline: t('landing.delete_pages_from_pdf.CTA.title'),
    subtitle: t('landing.delete_pages_from_pdf.CTA.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('main_page.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.delete_pages_from_pdf.how_to.h2'),
    subtitle_1: t('landing.delete_pages_from_pdf.h1.subtitle'),
    img: how_to_delete_pages_pdf,
    description: [
      {
        icon: icon_1,
        text: t('landing.delete_pages_from_pdf.how_to.first')
      },
      {
        icon: icon_2,
        text: t('landing.delete_pages_from_pdf.how_to.second')
      },
      {
        icon: icon_3,
        text: t('landing.delete_pages_from_pdf.how_to.third')
      }
    ]
  },
  title: t('meta.delete_pages_from_pdf.title'),
  description: t('meta.delete_pages_from_pdf.description'),
  fag: {
    question: 'Convert a PDF file to Word online in a few steps!',
    answer:
      '1. To convert a PDF file, upload it using the button "Upload" above or Drag&Drop. 2. Edit your PDF document using our tools and convert it to Word with one click. 3. Download or share the Word file.'
  },
  name: t('meta.delete_pages_from_pdf.title'),
  nameKey: 'landing.delete_pages_from_pdf.name',
  from: InternalFileType.PDF,
  to: InternalFileType.PDF,
  availableFormats: '.pdf'
});

const organizePdfService = (t: TFunction): IService => ({
  serviceType: EServiceType.EDITOR,
  path: 'organize-pdf',
  key: 'organize-pdf',
  mainColor: 'berry',
  uploadSectionImage: edit_pdf,
  uploadSection: {
    from: InternalFileType.PDF,
    to: InternalFileType.PDF,
    headline: t('landing.organize_pdf.h1.title'),
    subtitle_1: t('landing.organize_pdf.h1.subtitle')
  },
  banner: {
    headline: t('landing.organize_pdf.CTA.title'),
    subtitle: t('landing.organize_pdf.CTA.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('landing.organize_pdf.CTA.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.organize_pdf.how_to.h2'),
    img: how_to_edit_pdf,
    description: [
      { icon: icon_1, text: t('landing.organize_pdf.how_to.first') },
      { icon: icon_2, text: t('landing.organize_pdf.how_to.second') },
      { icon: icon_3, text: t('landing.organize_pdf.how_to.third') }
    ]
  },
  title: t('meta.organize_pdf.title'),
  description: t('meta.organize_pdf.description'),
  fag: {
    question: 'How to organize PDF pages online in a few steps?',
    answer: '1. Upload your PDF. 2. Reorder, rotate, or delete pages. 3. Download or share the organized PDF.'
  },
  name: t('meta.organize_pdf.title'),
  nameKey: 'landing.organize_pdf.name',
  from: InternalFileType.PDF,
  to: InternalFileType.PDF,
  availableFormats: '.pdf',
  funnel: EFunnels.ORGANIZE_PDF
});

const extractPdfPagesService = (t: TFunction): IService => ({
  serviceType: EServiceType.SPLITTER,
  path: 'extract-pdf-pages',
  key: 'extract-pdf-pages',
  mainColor: 'berry',
  uploadSectionImage: split_pdf,
  uploadSection: {
    from: InternalFileType.PDF,
    to: InternalFileType.PDF,
    headline: t('landing.extract_pdf_pages.h1.title'),
    subtitle_1: t('landing.extract_pdf_pages.h1.subtitle')
  },
  banner: {
    headline: t('landing.extract_pdf_pages.CTA.title'),
    subtitle: t('landing.extract_pdf_pages.CTA.subtitle'),
    format: InternalFileType.PDF,
    buttonLabel: t('landing.extract_pdf_pages.CTA.buttonLabel')
  },
  howTo: {
    headline_1: t('landing.extract_pdf_pages.how_to.h2'),
    img: how_to_edit_pdf,
    description: [
      { icon: icon_1, text: t('landing.extract_pdf_pages.how_to.first') },
      { icon: icon_2, text: t('landing.extract_pdf_pages.how_to.second') },
      { icon: icon_3, text: t('landing.extract_pdf_pages.how_to.third') }
    ]
  },
  title: t('meta.extract_pdf_pages.title'),
  description: t('meta.extract_pdf_pages.description'),
  fag: {
    question: 'Extract pages from a PDF in a few steps!',
    answer: '1. Upload your PDF. 2. Select pages to extract. 3. Download or share the new PDF.'
  },
  name: t('meta.extract_pdf_pages.title'),
  nameKey: 'landing.extract_pdf_pages.name',
  from: InternalFileType.PDF,
  to: InternalFileType.PDF,
  availableFormats: '.pdf',
  funnel: EFunnels.EXTRACT_PDF_PAGES
});

export const editorServicesList = (t: TFunction): IService[] => {
  return [
    editPdfService(t),
    signPdfService(t),
    fillPdfService(t),
    compressPdfService(t),
    pdfOcrService(t),
    translatePdfService(t),
    imageToTextService(t),
    splitPdfService(t),
    deletePagesFromPdfService(t),
    organizePdfService(t),
    extractPdfPagesService(t)
  ];
};
